import { fetchWrapper, IBaseResponse, extractPaginationInfo } from '../apiBase';
import { BASE_API_URL } from '@/config/environment';
import { IRepository } from '@/types';

export type TFormFieldDefinition = {
  type:
  | 'string'
  | 'date'
  | 'country'
  | 'number'
  | 'email'
  | 'tel'
  | 'url'
  | 'checkbox'
  | 'radio'
  | 'select'
  | 'textarea';
  title: string;
  fieldIndex: number;
  placeholder?: string;
  default?: string | null;
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  min?: number;
  max?: number;
  step?: number;
  pattern?: string;
  options?: string[];
};

export type TFormDefinition = {
  title: string;
  description?: string;
  fields: Record<string, TFormFieldDefinition>;
};

export type IGatedAccessPolicy = {
  id: string;
  access_form_schema: TFormDefinition | null;
  intro_title: string;
  intro_content: string;
  license_statement: string;
  requires_approval: string;
  updated_at: string;
};

export interface IGatedAccessPolicyResponse extends IBaseResponse {
  policy: IGatedAccessPolicy | null;
}

export const fetchGatedAccessPolicy = async ({
  repository,
  token,
}: {
  repository: IRepository;
  token?: string;
}): Promise<IGatedAccessPolicyResponse> => {
  const { namespace, name: repositoryName } = repository;
  const targetUrl = `${BASE_API_URL}/repos/${repository.namespace}/${repository.name}/gated_access_policy`;
  // console.log('fetchEvaluations', targetUrl);
  const data = await fetchWrapper({
    resourceName: 'gated_access_policy',
    targetUrl,
    authToken: token,
    resourceContext: { namespace, repositoryName },
  });
  // console.log('fetchEvaluations > data', data);
  return data;
};

type ICreateGatedAccessPolicyParams = {
  repository: IRepository;
  token?: string;
  access_form_schema: TFormDefinition | null;
  license_statement: string;
  intro_title: string;
  intro_content: string;
  requires_approval?: boolean;
};

export const createGatedAccessPolicy = async ({
  repository,
  token,
  access_form_schema,
  license_statement,
  intro_title,
  intro_content,
  requires_approval,
}: ICreateGatedAccessPolicyParams): Promise<IGatedAccessPolicyResponse> => {
  const { namespace, name: repositoryName } = repository;
  const targetUrl = `${BASE_API_URL}/repos/${repository.namespace}/${repository.name}/gated_access_policy`;

  const body = {
    access_form_schema,
    license_statement,
    intro_title,
    intro_content,
    requires_approval,
  };

  // console.log('createEvaluation > body', body);

  const data = await fetchWrapper({
    resourceName: 'createGatedAccessPolicy',
    method: 'POST',
    contentType: 'application/json',
    targetUrl,
    authToken: token,
    resourceContext: { namespace, repositoryName },
    body: JSON.stringify(body),
  });

  return data;
};
